import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { productCenterContent } from '@/mocks/products';

// 用户将提供实际平台链接，替换此处即可
const PLATFORM_URL = '#';

const advantages = [
  {
    num: '01',
    title: '软硬一体化',
    desc: '通过数据平台集成Usbserver，进行网银Agent训练、定时任务执行。并对网银数据标准化处理，实现软硬件一体化。',
    icon: 'ri-cpu-line',
  },
  {
    num: '02',
    title: '安全无死角',
    desc: '采用SM4国密算法通过落盘加密，实现网银账户录入即加密，Agent在录入网银输入框前解密，全流程无泄漏风险。',
    icon: 'ri-shield-check-line',
  },
  {
    num: '03',
    title: '网银智能化',
    desc: '唯一一家通过大模型+智能体方式实现网银智能化的厂商，让网银操作从人工逐笔走向自动智能。',
    icon: 'ri-robot-2-line',
  },
  {
    num: '04',
    title: '网银业务一体化',
    desc: '实现网银自动下载+支付+复核业务一体化的业务平台，打通资金流转全链路，告别多系统来回切换。',
    icon: 'ri-links-line',
  },
];

const businessLines = [
  {
    title: '余额查询',
    subtitle: '多账户资金状态统一查询，全流程可追溯',
    desc: '余额查询支持列表检索、新建查询、定时任务配置与执行链路追踪，统一展示查询结果、执行状态和完成时间；通过UKey自动化执行并记录完整任务链路，让多账户资金核对更高效、过程更透明、结果可追溯。',
    icon: 'ri-wallet-3-line',
    reverse: false,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20enterprise%20banking%20balance%20inquiry%20interface%20with%20account%20balance%20cards%20and%20fund%20position%20summary%20clean%20professional%20SaaS%20dashboard%20UI%20soft%20neutral%20warm%20tones%20no%20blue%20or%20purple%20elegant%20corporate%20financial%20software%20aesthetic&width=800&height=500&seq=fund-biz-01&orientation=landscape',
    videoUrl:
      'https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/de47bb9b-ce65-4339-a103-999fc3bd2e59_1.mov',
    features: [
      { name: '余额查询列表', desc: '支持列表检索，统一展示查询结果、执行状态和完成时间' },
      { name: '新建余额查询单', desc: '快速创建查询任务，指定查询账户与查询条件' },
      { name: '定时任务配置', desc: '灵活设置自动化查询周期，定时触发余额采集' },
      { name: '执行链路', desc: '完整记录任务执行全过程，每一步状态实时追踪' },
    ],
  },
  {
    title: '流水下载与解析',
    subtitle: '账户流水统一检索，收支明细清晰可追溯',
    desc: '流水查询支持列表检索、新建查询、定时任务配置与详情查看，统一呈现查询任务、收支汇总与明细记录，并可追踪执行链路，提升账户流水核对效率。U盾服务器设备+网银Agent自动采集流水数据，自动解析并提取各网银数据，生成标准收支明细记录与资金日报表，实现可视化展示与消息通知。',
    icon: 'ri-download-cloud-line',
    reverse: true,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20enterprise%20banking%20transaction%20flow%20download%20and%20parsing%20interface%20with%20data%20table%20and%20automated%20processing%20pipeline%20clean%20professional%20SaaS%20dashboard%20soft%20neutral%20warm%20tones%20no%20blue%20or%20purple%20elegant%20corporate%20fintech%20aesthetic&width=800&height=500&seq=fund-biz-02&orientation=landscape',
    features: [
      { name: '流水查询单列表', desc: '支持列表检索，统一呈现查询任务、收支汇总与明细记录' },
      { name: '新建流水查询单', desc: '快速创建流水查询任务，指定查询账户与查询时间范围' },
      { name: '定时任务配置', desc: '灵活设置自动化流水采集周期，定时触发批量下载' },
      { name: '流水详情', desc: '查看单笔流水明细，收支记录清晰可追溯' },
    ],
  },
  {
    title: '回单下载与回单管理',
    subtitle: '电子回单集中查询与在线查看',
    desc: '回单管理支持按账户和交易信息统一检索、批量下载并在线查看原始电子回单，方便凭证核对、归档与审计追溯。U盾服务器设备+网银Agent自动登陆网银系统，查询并下载网银流水回单，上传至回单管理平台后进行数据清洗、结构转换与流水日记账自动挂接，最终回单推至企业财务系统。',
    icon: 'ri-file-list-3-line',
    reverse: false,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20enterprise%20banking%20receipt%20download%20and%20management%20interface%20with%20electronic%20document%20list%20and%20matching%20status%20clean%20professional%20SaaS%20dashboard%20soft%20neutral%20warm%20tones%20no%20blue%20or%20purple%20elegant%20corporate%20financial%20software%20aesthetic&width=800&height=500&seq=fund-biz-03&orientation=landscape',
    features: [
      { name: '回单列表', desc: '按账户和交易信息统一检索，统一呈现回单记录与执行状态' },
      { name: '查看电子回单', desc: '在线查看原始电子回单，方便凭证核对、归档与审计追溯' },
      { name: '执行链路', desc: '完整记录回单下载全过程，每一步状态实时追踪' },
      { name: '批量下载', desc: '支持批量下载回单文件，提升凭证处理效率' },
    ],
  },
  {
    title: '转账与复核管理',
    subtitle: '转账制单与复核一体化，付款双人管控更安全',
    desc: '转账管理覆盖制单与复核全流程，构建资金支付安全闭环。平台通过API接口获取审批后的支付信息，自动登录网银系统完成各银行制单，制单完成后即时通知业务人员复核，复核结果自动返回业务系统；结合复核策略与权限配置，实现制单与复核双人管控，让资金支付更规范、更安全。',
    icon: 'ri-bank-card-line',
    reverse: true,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20minimalist%20enterprise%20banking%20transfer%20and%20approval%20management%20interface%20with%20payment%20workflow%20and%20review%20status%20clean%20professional%20SaaS%20dashboard%20soft%20neutral%20warm%20tones%20no%20blue%20or%20purple%20elegant%20corporate%20fintech%20aesthetic&width=800&height=500&seq=fund-biz-04&orientation=landscape',
    features: [
      { name: '转账制单', desc: '付款与收款信息集中配置，自动登录网银完成各银行制单' },
      { name: '转账单管理', desc: '转账单统一管理与查看，制单与复核状态一目了然' },
      { name: '复核任务列表', desc: '待复核、已复核任务统一管理，复核进度与结果实时可查' },
      { name: '复核策略配置', desc: '按金额、账户灵活配置复核规则，支持多级复核管控' },
    ],
  },
];

export default function ProductFundDetail() {
  const product = productCenterContent.items.find(
    (item) => item.slug === 'fund-platform',
  );
  const otherProducts = productCenterContent.items.filter(
    (item) => item.slug !== 'fund-platform',
  );

  const [showVideo, setShowVideo] = useState(false);

  if (!product) return null;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Header */}
        <section className="pt-28 md:pt-36 pb-10 md:pb-14 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <nav className="mb-8 flex items-center gap-2 text-sm text-foreground-300">
              <Link to="/" className="hover:text-primary-400 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <Link
                to="/product-center"
                className="hover:text-primary-400 transition-colors"
              >
                产品中心
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-100 font-medium">
                {product.titleCn}
              </span>
            </nav>

            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
              <div className="max-w-3xl">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
                    <i className={`${product.icon} text-2xl`} />
                  </div>
                  <span className="text-sm font-medium text-primary-400 tracking-wide font-label">
                    {product.titleEn}
                  </span>
                </div>
                <h1 className="text-3xl md:text-5xl font-black text-foreground-50 font-heading">
                  {product.titleCn}
                </h1>
                <p className="mt-5 text-base md:text-lg text-foreground-300 leading-relaxed max-w-2xl">
                  {product.desc}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="pb-16 md:pb-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                    产品介绍
                  </h2>
                  <div className="flex-1 h-px bg-background-200/60" />
                </div>
                <p className="text-sm md:text-base text-foreground-300 leading-loose">
                  {product.intro}
                </p>
                <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {advantages.map((adv) => (
                    <div
                      key={adv.num}
                      className="flex items-start gap-3 p-4 rounded-lg bg-background-100/60 border border-background-200/40"
                    >
                      <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500/10 text-primary-500 shrink-0">
                        <i className={`${adv.icon} text-base`} />
                      </div>
                      <div>
                        <h4 className="text-sm font-bold text-foreground-50">
                          {adv.title}
                        </h4>
                        <p className="mt-0.5 text-xs text-foreground-400 leading-relaxed line-clamp-2">
                          {adv.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden border border-background-200/50">
                <img
                  src={product.image}
                  alt={product.titleCn}
                  title={`${product.titleCn} ${product.titleEn}`}
                  className="w-full h-64 md:h-80 object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Core capabilities from mock data */}
        <section className="bg-background-100 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="flex items-end justify-between">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                  核心能力
                </h2>
                <div className="mt-4 w-12 h-0.5 bg-primary-500 rounded-full" />
              </div>
              <span className="hidden sm:block text-sm text-foreground-300 font-label">
                共 {product.features.length} 项
              </span>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
              {product.features.map((feature, idx) => (
                <div
                  key={feature.title}
                  className="group relative bg-background-50 rounded-lg border border-background-200/50 p-8 md:p-10 overflow-hidden transition-all duration-300 hover:border-primary-500/40"
                >
                  <span className="absolute top-6 right-6 text-5xl md:text-6xl font-black text-background-200 group-hover:text-primary-400/20 transition-colors font-heading leading-none">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <div className="relative">
                    <div className="w-14 h-14 flex items-center justify-center rounded-lg bg-background-100 text-primary-500 mb-6 group-hover:bg-primary-500 group-hover:text-foreground-50 transition-colors">
                      <i className={`${feature.icon} text-2xl`} />
                    </div>
                    <h3 className="text-lg md:text-xl font-bold text-foreground-50">
                      {feature.title}
                    </h3>
                    <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                      {feature.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Business Overview */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                业务总览
              </h2>
              <p className="mt-3 text-sm text-foreground-300">
                资金业务驾驶舱，一屏掌握集团资金运行全貌
              </p>
              <div className="mt-4 mx-auto w-12 h-0.5 bg-primary-500 rounded-full" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
              <div>
                <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-8">
                  业务总览集中呈现当前存款、当日收支、待关联回单、流水采集及执行异常等核心指标，并通过资金流转趋势和资金维度结构，帮助管理人员快速掌握资金运行状况。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { label: '当前存款', icon: 'ri-safe-2-line' },
                    { label: '当日收支', icon: 'ri-exchange-dollar-line' },
                    { label: '待关联回单', icon: 'ri-file-list-3-line' },
                    { label: '流水采集', icon: 'ri-flow-chart' },
                    { label: '执行异常', icon: 'ri-error-warning-line' },
                    { label: '资金趋势', icon: 'ri-line-chart-line' },
                  ].map((item) => (
                    <div
                      key={item.label}
                      className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/50"
                    >
                      <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500/10 text-primary-500">
                        <i className={`${item.icon} text-base`} />
                      </div>
                      <span className="text-sm font-medium text-foreground-50">
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-lg overflow-hidden border border-background-200/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20enterprise%20financial%20dashboard%20with%20fund%20overview%20panels%20showing%20balance%20cards%20trend%20charts%20and%20structure%20analysis%20in%20clean%20light%20interface%20professional%20corporate%20treasury%20management%20SaaS%20UI%20soft%20neutral%20tones%20no%20blue%20or%20purple%20elegant%20data%20visualization&width=800&height=500&seq=fund-overview-01&orientation=landscape"
                  alt="资金业务总览驾驶舱"
                  title="资金业务总览驾驶舱"
                  className="w-full h-56 md:h-80 object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Business Lines Overview */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                业务功能矩阵
              </h2>
              <p className="mt-3 text-sm text-foreground-300">
                覆盖余额、流水、回单、转账四大核心网银业务线
              </p>
              <div className="mt-4 mx-auto w-12 h-0.5 bg-primary-500 rounded-full" />
            </div>

            <div className="space-y-16 md:space-y-24">
              {businessLines.map((line, idx) => (
                <div
                  key={line.title}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                    idx > 0
                      ? 'pt-16 md:pt-24 border-t border-background-200/30'
                      : ''
                  }`}
                >
                  <div className={line.reverse ? 'order-1 lg:order-2' : ''}>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
                        <i className={`${line.icon} text-lg`} />
                      </div>
                      <div>
                        <h3 className="text-lg md:text-xl font-bold text-foreground-50">
                          {line.title}
                        </h3>
                        <p className="text-xs text-primary-400 font-medium mt-0.5">
                          {line.subtitle}
                        </p>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-300 leading-relaxed">
                      {line.desc}
                    </p>
                    {line.features ? (
                      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {line.features.map((f) => (
                          <div
                            key={f.name}
                            className="flex items-start gap-2.5 p-3 rounded-md bg-background-100 border border-background-200/40"
                          >
                            <div className="w-5 h-5 flex items-center justify-center rounded bg-primary-500/10 text-primary-500 mt-0.5 shrink-0">
                              <i className="ri-check-line text-xs" />
                            </div>
                            <div>
                              <span className="text-sm font-medium text-foreground-50 block">
                                {f.name}
                              </span>
                              <span className="text-xs text-foreground-400 leading-relaxed">
                                {f.desc}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-foreground-400">
                        <i className="ri-information-line" />
                        <span>详细功能说明与演示视频将在后续补充</span>
                      </div>
                    )}
                  </div>
                  <div
                    className={`relative rounded-lg overflow-hidden border border-background-200/50 ${
                      line.reverse ? 'order-2 lg:order-1' : ''
                    }`}
                  >
                    <img
                      src={line.image}
                      alt={`${line.title}界面`}
                      title={`${line.title} - ${line.subtitle}`}
                      className="w-full h-56 md:h-72 object-cover object-top"
                    />
                    {idx === 0 && line.videoUrl ? (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="absolute inset-0 bg-black/30" />
                        <button
                          type="button"
                          onClick={() => setShowVideo(true)}
                          className="relative inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-50/95 text-foreground-950 text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          <i className="ri-play-circle-fill text-lg" />
                          查看演示视频
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA - Platform entry point */}
        <section className="bg-primary-500 py-16 md:py-24">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-foreground-50/10 text-foreground-50 mx-auto mb-6">
              <i className="ri-external-link-line text-2xl" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-4">
              立即体验网银业务智管平台
            </h2>
            <p className="text-base text-foreground-100/80 max-w-2xl mx-auto mb-10 leading-relaxed">
              一体化的网银业务管理，让余额、流水、回单、转账业务高效协同，资金安全全程可控。
            </p>
            <a
              href={PLATFORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-50 text-primary-500 text-base font-semibold rounded-lg hover:bg-background-50 transition-colors whitespace-nowrap"
            >
              进入平台
              <i className="ri-arrow-right-line" />
            </a>
            <p className="mt-4 text-xs text-foreground-100/60">
              请点击上方按钮跳转至网银业务智管平台进行体验
            </p>
          </div>
        </section>

        {/* Other products */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-8 lg:px-12 xl:px-20 max-w-[1400px] mx-auto">
            <div className="flex items-end justify-between">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
                  其它产品
                </h2>
                <div className="mt-4 w-12 h-0.5 bg-primary-500 rounded-full" />
              </div>
              <Link
                to="/product-center"
                className="inline-flex items-center gap-2 text-sm font-medium text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {otherProducts.map((item) => (
                <Link
                  key={item.slug}
                  to={`/product-center/${item.slug}`}
                  className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/40 transition-all duration-300"
                >
                  <div className="relative w-full h-44 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.titleCn}
                      title={`${item.titleCn} ${item.titleEn}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                    <div className="absolute bottom-3 left-4 w-10 h-10 flex items-center justify-center rounded-lg bg-background-50/90 text-primary-500">
                      <i className={`${item.icon} text-lg`} />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-base md:text-lg font-bold text-foreground-50 group-hover:text-primary-400 transition-colors">
                      {item.titleCn}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-300 leading-relaxed line-clamp-2">
                      {item.desc}
                    </p>
                    <div className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-foreground-400 group-hover:text-primary-400 transition-colors">
                      <span>查看详情</span>
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
        {/* Video Modal */}
        {showVideo && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
            onClick={() => setShowVideo(false)}
          >
            <div
              className="relative w-full max-w-5xl bg-black rounded-xl overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between px-4 py-3 bg-background-950 border-b border-background-800">
                <span className="text-sm font-medium text-foreground-50">
                  余额查询 — 演示视频
                </span>
                <button
                  type="button"
                  onClick={() => setShowVideo(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:text-foreground-50 hover:bg-background-800 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-lg" />
                </button>
              </div>
              <div className="aspect-video">
                <video
                  src="https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/de47bb9b-ce65-4339-a103-999fc3bd2e59_1.mov"
                  controls
                  autoPlay
                  className="w-full h-full"
                >
                  您的浏览器不支持视频播放
                </video>
              </div>
            </div>
          </div>
        )}

      </main>
      <Footer />
    </div>
  );
}